import { render, staticRenderFns } from "./channelDataBackup.vue?vue&type=template&id=6f4952c6&scoped=true&"
import script from "./channelDataBackup.vue?vue&type=script&lang=js&"
export * from "./channelDataBackup.vue?vue&type=script&lang=js&"
import style0 from "./channelDataBackup.vue?vue&type=style&index=0&id=6f4952c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4952c6",
  null
  
)

export default component.exports